module.exports = __webpack_public_path__ + "static/img/Xeo_Logo-White.9f4b5e1b.png";